import { useEffect } from "react";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { withRouter } from "../../../shared/utility";

import { useParams, useNavigate } from "react-router-dom";

import { UserBusinessDetailsViewModel } from "../../../viewmodels/setup/userBusiness/UserBusinessDetailsViewModel";
import  UserBusinessDetailsForm from "../../../components/forms/userBusiness/UserBusinessDetailsForm";

function UserBusinessDetails(props) {
  const { logout } = props;

  let { userBusinessId } = useParams();

  const {
   createUserBusiness,
    updateUserBusiness,
    getUserBusiness,
    userBusinessess,
    loading,
    emptyModal,
    getUserBusinessForDropdown,
  } = UserBusinessDetailsViewModel(logout, userBusinessId);

  const onStartDependencides = async function () {
    getUserBusiness();
  };

  useEffect(() => {
    if (userBusinessId && userBusinessId !== "create") {
      console.log("fetching user business details",userBusinessId);
      onStartDependencides();
    } 
    
  }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-8 space-y-4">

      <div className="card-custom">
        {loading ? null : (
          <UserBusinessDetailsForm
            isEdit={userBusinessId}
            actionCall={(values) => {
              if (userBusinessId && userBusinessId !== "create") {
                updateUserBusiness(values);
              } else {
                createUserBusiness(values);
              }
            }}
           
            userBusinessess={userBusinessess}
          />
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserBusinessDetails)
);
